import * as screenfull from 'screenfull';

import events from "../../events/EventsObservable";
import {ACTION_EVENTS} from "../UserAction";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import SystemPlatform from "../../system/SystemPlatform";
import {injectable, inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import {isInIframe} from "../../helpers";

export const FULLSCREEN_EVENTS = {
    "FULLSCREEN_REQUEST": "FULLSCREEN_REQUEST",
    "FULLSCREEN_CHANGE": "FULLSCREEN_CHANGE"
};

@injectable()
export default class Fullscreen {

    private _config: SystemConfig;
    private _gameset: any;
    // private _app: IApp;
    private _platform: SystemPlatform;

    private _fullscreenEnabled: boolean = true;
    private _fullscreenEnabledTmp: boolean = true;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    ) {
        this._config = config;
        this._gameset = config.gameset;
        this._platform = config.platform;

        events.subscribe(ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST, this);
        events.subscribe(ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST, this);
        events.subscribe(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_UP, this);
        events.subscribe(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_DOWN, this);
        events.subscribe(ACTION_EVENTS.ACTION_SOUND_CHOOSE, this);


        document.addEventListener("fullscreenchange", this._onFullScreenChange, false);
        document.addEventListener("webkitfullscreenchange", this._onFullScreenChange, false);
        document.addEventListener("mozfullscreenchange", this._onFullScreenChange, false);
    }

    notify(eventName, data) {
        switch(eventName) {
            case ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST:
            case ACTION_EVENTS.ACTION_SOUND_CHOOSE:
            case ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_UP:
                this._fullscreenRequest();
                break;

            case ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST:
            case ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_DOWN:
                this._fullscreenExit();
                break;
        }
    }

    isFullscreenEnabled(): boolean {
        return this._fullscreenEnabled;
    }

    gameplayDisableFullscreen() {
        this._fullscreenEnabledTmp = this._fullscreenEnabled;
        this._fullscreenEnabled = false;
    }

    gameplayEnableFullscreen() {
        this._fullscreenEnabled = this._fullscreenEnabledTmp;
    }

    _fullscreenRequest() {

        if(
            !this._fullscreenEnabled ||
            this._config.get(CONFIG_PARAMS.DISABLE_FULLSCREEN) ||
            !this._config.get(CONFIG_PARAMS.FULLSCREEN) ||
            isInIframe() ||
            !screenfull
        ) {
            return;
        }

        if (screenfull?.isEnabled) {
            screenfull?.request && screenfull.request().catch((event) => {
                console.log('Failed to enable fullscreen', event);
                this._fullscreenEnabled = false
            })
        }
    }

    _fullscreenExit() {

        if(!this._fullscreenEnabled) {
            return;
        }

        // @ts-ignore
        screenfull?.exit && screenfull.exit();
    }

    _onFullScreenChange() {

        // @ts-ignore
        let fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
        events.dispatch(FULLSCREEN_EVENTS.FULLSCREEN_CHANGE, {inFullscreen: !!fullscreenElement});
    }
}
